import useConfigCode from "@/features/sub-families/hooks/use-config-code.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { getMountingKitByConfigCode } from "@/services/product/utils/mounting-kits.ts";
import { SmartNumberDescriptor } from "@/types";

export default function useCurrentMountingKit() {
    const product = useCurrentProduct();
    const { getConfigCodeByDescriptor } = useConfigCode();

    return getMountingKitByConfigCode(product, getConfigCodeByDescriptor(SmartNumberDescriptor.MountingKit));
}
